import React/*, {useEffect, useState}*/ from "react"
// import ReactModal from 'react-modal'
import "./sigevents.css"
// import anime from 'animejs/lib/anime.es.js';


const signatureEvents = ( ) => {


    return (
        <section className="sigevents" id="SignatureEvents">
            <div className="containfix">
                <h1>DON'T MISS SCOOP NEWS GROUP'S SIGNATURE CONTENT DURING AI WEEK</h1>
                <div className="grid2col">
                <div className="gridcalcell">
                    <div className="calIconContainer">
                    <img
                        src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/defense-tech-week/2023/Calendar_Blank.png"
                        className="calImage"
                        alt="Calendar icon"
                    />
                    <p className="centered">4.21</p>
                    </div>
                    <div className="calText">
                    <div className="calTime">5:30 PM ET</div>
                    <div className="calTitle">AI Week Opening Party</div>
                    </div>
                    <div className="calbtncontain">
                    <a
                        href="mailto:festivals@scoopnewsgroup.com?subject=AI Week Opening Party Registration Request"
                        className="regsigbutton"
                        target="_blank" rel="noreferrer"
                    >
                        REQUEST TO ATTEND
                    </a>
                    </div>
                </div>
                <div className="gridcalcell">
                    <div className="calIconContainer">
                    <img
                        src="https://sng-client-assets.s3.amazonaws.com/fedscoop/upgather/defense-tech-week/2023/Calendar_Blank.png"
                        className="calImage"
                    />
                    <p className="centered">4.24</p>
                    </div>
                    <div className="calText">
                    <div className="calTime">8:00 AM ET</div>
                    <div className="calTitle">AITalks</div>
                    </div>
                    <div className="calbtncontain">
                    <a
                        href="https://aitalks.upgather.com"
                        className="regsigbutton"
                        target="_blank" rel="noreferrer"
                    >
                        REGISTER
                    </a>
                    </div>
                </div>
                </div>
                
            </div>

        </section>

    )
}
export default signatureEvents
